<template>
    <DCardBody class="p-3 mb-2 bg-warning text-white">
        {{ __('products.products.form.sub_type_hint') }}
    </DCardBody>
    <DCard
        padding
    >
        <DTable
            :items="productSubTypes"
            :fields="[
                {key: 'sub_type', label: __('products.subTypes.table.headers.subType')},
                {key: 'actions', label: '',_style: { minWidth: '5%' }}
            ]"
            hover
        >
            <template #sub_type="{item}">
                <td>
                    {{ item.sub_type }}
                </td>
            </template>
            <template #actions="{item}">
                <td>
                    <div style="display: flex; grid-gap: 10px">
                        <DButton
                            :id="`edit_${item.sub_type}`"
                            mini
                            icon="pencil"
                            @click="editSubType(item.id)"
                        />
                        <DButton
                            v-if="item.sub_type"
                            :id="`btn-delete-${item.sub_type}`"
                            mini
                            icon="trash-can-outline"
                            color="danger"
                            :disabled="isInLoadingState"
                            @click="deleteSubType(item.id, item.sub_type)"
                        />
                    </div>
                </td>
            </template>
        </DTable>

        <DFabs>
            <DFab
                id="btn-add"
                icon="plus"
                :label="__('products.subTypes.buttons.add')"
                @click="createSubType"
            />
        </DFabs>

        <DModal
            v-model:show="showConfirmationModal"
            :title="__('products.subTypes.modal.header')"
            :message="__('products.subTypes.modal.text',{subType: subTypeNameToDelete})"
            is-confirm
            is-error
            @close="showConfirmationModal = false"
            @confirm="deleteCallBack"
        />
    </DCard>
</template>

<script setup>
import { ref } from 'vue'
import { router } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'

const showConfirmationModal = ref(false)
const subTypeNameToDelete = ref('')
const subTypeId = ref('')

defineProps({
    productSubTypes: {
        type: Array,
        default: () => {
            return []
        }
    }
})
function editSubType (subType) {
    return router.get(route('products.sub-types.edit', { sub_type: subType }))
}
function deleteSubType (id, subTypeName) {
    showConfirmationModal.value = true
    subTypeNameToDelete.value = subTypeName
    subTypeId.value = id
}
function deleteCallBack () {
    showConfirmationModal.value = false
    router.delete(route('products.sub-types.destroy', { sub_type: subTypeId.value }))
}
function createSubType () {
    return router.get(route('products.sub-types.create'))
}
</script>

<style scoped lang="scss">

</style>
